import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useParams } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const UserConversation = () => {
  const { id } = useParams(); 
  const [conversation, setConversation] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConversation = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/conversations/get-chat-list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ lead_id: id }),
          }
        );
        const data = await response.json();
        setConversation(data.chat_list); 
      } catch (error) {
        console.error("Error fetching conversation:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConversation();
  }, [id]);

  if (loading) {
    return <Typography variant="h6">Loading...</Typography>;
  }

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Chat Insights for Your Journey
      </Typography>
      <Paper
        elevation={3}
        style={{ padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <Typography variant="h6">Conversation Summary</Typography>
        <List>
          {conversation.map((msg) => (
            <ListItem key={msg.id}>
              <div className="grid grid-cols-2 gap-5">
                <div>
                  <ListItemText
                    primary={`Client: ${msg.input}`}
                    secondary={`Ailaa AI: ${msg.output}`}
                  />
                </div>
                <div className="grid grid-cols-2">
                  <div className="flex items-center">
                    <Typography variant="caption" color="text.secondary">
                      Date: {new Date(msg.timestamp).toLocaleDateString()}
                    </Typography>
                  </div>
                  <div className="flex items-center">
                    <Typography variant="caption" color="text.secondary">
                      Time: {new Date(msg.timestamp).toLocaleTimeString()}
                    </Typography>
                  </div>
                </div>
              </div>
            </ListItem>
          ))}
        </List>
      </Paper>
      <Button
        variant="contained"
        color="primary"
        size="large"
        fullWidth
        sx={{ mt: { xs: 1, sm: 0 } }}
      >
        Chat on Whatsapp
      </Button>
    </Container>
  );
};

export default UserConversation;
